<div #editor
     style="background-color: var(--py-arkaplan); color: var(--py-metin);">

    <div class="ui block header flex"
         style="display: flex;padding: 0.2rem;margin-bottom: 0;"
         *ngIf="!saltOkunur">
        <div style="display: flex;"
             tabindex="-1">

            <input type="color" value="#000000" (change)="execCommand('foreColor',true, $event.target)"
                (input)="execCommand('foreColor',true, $event.target)" style="width: 2rem;padding:0" tabindex="-1">
            <input type="color" value="#ffffff" (change)="execCommand('backColor',true, $event.target)"
                (input)="execCommand('backColor',true, $event.target)" style="width: 2rem;padding:0" tabindex="-1">

            <button type="button"
                    (click)="execCommand('justifyFull')"
                    class="ui icon mini button"
                    tabindex="-1">
                <i class="icon align justify"></i>
            </button>

            <button type="button"
                    (click)="execCommand('justifyLeft')"
                    class="ui icon mini button"
                    tabindex="-1">
                <i class="icon align left"></i>
            </button>

            <button type="button"
                    (click)="execCommand('justifyCenter')"
                    class="ui icon mini button"
                    tabindex="-1">
                <i class="icon align center"></i>
            </button>

            <button type="button"
                    (click)="execCommand('justifyRight')"
                    class="ui icon mini button"
                    tabindex="-1">
                <i class="icon align right"></i>
            </button>

            <button type="button"
                    (click)="execCommand('bold')"
                    class="ui icon mini button"
                    tabindex="-1">
                <i class="icon bold"></i>
            </button>

            <button type="button"
                    (click)="execCommand('italic')"
                    class="ui icon mini button"
                    tabindex="-1">
                <i class="icon italic"></i>
            </button>

            <button type="button"
                    (click)="execCommand('underline')"
                    class="ui icon mini button"
                    tabindex="-1">
                <i class="icon underline"></i>
            </button>


            <button type="button"
                    (click)="execCommand('strikeThrough')"
                    class="ui icon mini button"
                    tabindex="-1">
                <i class="icon strikethrough"></i>
            </button>

        </div>

        <div style="display: flex;margin-left: auto;gap: 4px;align-items: center;">
            <button type="button"
                    (click)="execCommand('removeFormat')"
                    class="ui icon mini button"
                    tabindex="-1">
                <i class="icon remove format"></i>
            </button>

            <button type="button"
                    class="ui icon mini button"
                    tabindex="-1"
                    *ngIf="kaydetTusu"
                    (click)="tiklandiKaydet.emit(html);">
                <i class="save icon"></i>
            </button>
        </div>
    </div>

    <div class="editor-wrapper">
        <div #textEditor
             text-editable
             [(ngModel)]="html"
             [attr.contenteditable]="!saltOkunur"
             spellcheck="false"
             [disabled]="saltOkunur"
             [attr.placeholder]="html=='' ? saltOkunur? '':'Ne Haber':'Açıklama Yok'"
             [attr.tabindex]="saltOkunur ? undefined:undefined"
             class="aciklama-div"
             (keydown)="editorKeydown($event)"
             (input)="editorInput()"></div>

        <div *ngIf="mentionAcik && mentionSonuclar.length > 0" class="mention-dropdown">
            <div *ngFor="let k of mentionSonuclar; let i = index"
                 class="mention-oge"
                 [class.mention-oge--aktif]="i === mentionSeciliIndex"
                 (mousedown)="$event.preventDefault()"
                 (click)="mentionSec(k)">
                <span class="mention-oge-harf">{{ k.isim?.charAt(0)?.toUpperCase() || '?' }}</span>
                <span class="mention-oge-isim">{{ k.isim }}</span>
                <span *ngIf="k.kullaniciAdi" class="mention-oge-kadi">@{{ k.kullaniciAdi }}</span>
            </div>
        </div>

        <button *ngIf="!saltOkunur && sesKayitDestekleniyor"
                type="button"
                class="mikrofon-btn"
                [class.aktif]="sesKayitAktif"
                [title]="sesKayitAktif ? 'Ses kaydını durdur' : 'Konuşarak yaz'"
                tabindex="-1"
                (mousedown)="$event.preventDefault()"
                (click)="toggleSesKayit()">
            <i class="microphone icon" *ngIf="sesKayitAktif"></i>
            <i class="microphone slash icon" *ngIf="!sesKayitAktif"></i>
        </button>

        <div *ngIf="sesKayitAktif && geciciMetin" class="gecici-metin-gosterge">
            {{ geciciMetin }}
        </div>
    </div>

</div>
